import * as actions from '../actions/aircraft-availability';
import * as models from '../../domain/models';

export interface State {
  camberOptions: Array<models.CamberOption>;
  camberOptionsLoading: boolean;
  camberOptionsLoaded: boolean;
  smartJetDOptions: Array<models.SmartJetDOption>;
  smartJetDOptionsLoading: boolean;
  smartJetDOptionsLoaded: boolean;

}

const initialState: State = {
  camberOptions: [],
  camberOptionsLoading: false,
  camberOptionsLoaded: false,
  smartJetDOptions: [],
  smartJetDOptionsLoading: false,
  smartJetDOptionsLoaded: false,
};

export function reducer(state = initialState, action: actions.Actions): State {
  switch (action.type) {
    case actions.LOAD_CAMBER_OPTIONS: {
      return { ...state, camberOptionsLoading: true };
    }

    case actions.LOAD_CAMBER_OPTIONS_SUCCESS: {
      return {
        ...state,
        camberOptionsLoaded: true,
        camberOptionsLoading: false,
        camberOptions: action.payload,
      };
    }

    case actions.LOAD_SMART_JET_D_OPTIONS: {
      return {
        ...state,
        smartJetDOptionsLoading: true
      };
    }

    case actions.LOAD_SMART_JET_D_OPTIONS_SUCCESS: {
      return {
        ...state,
        smartJetDOptionsLoaded: true,
        smartJetDOptionsLoading: false,
        smartJetDOptions: action.payload,
      };
    }

    default: {
      return state;
    }
  }
}

export const getCamberOptions = (state: State) => state.camberOptions;
export const getCamberOptionsLoaded = (state: State) => state.camberOptionsLoaded;
export const getCamberOptionsLoading = (state: State) => state.camberOptionsLoading;

export const getSmartJetDOptions = (state: State) => state.smartJetDOptions;
export const getSmartJetDOptionsLoaded = (state: State) => state.smartJetDOptionsLoaded;
export const getSmartJetDOptionsLoading = (state: State) => state.smartJetDOptionsLoading;
